export default function filterReducer(arg, commentArr) {
  switch (arg) {
    case 'All comments':
      return commentArr;
    case 'Resolved comments':
      return commentArr.filter(comment => comment.resolved);
    case 'Open comments':
      return commentArr.filter(comment => !comment.resolved);
    default:
      return commentArr;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/utils/filterReducer.js